import { Avatar, Box, Link, Stack, Typography } from '@mui/material';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary, useIsDesktop } from 'Hooks';
import { PurpleOutlinedAlert } from 'Images';
import { replaceZerosWithHyphen } from 'Utils/replaceZerosWithHyphen';
import { Fragment } from 'react';

interface IAppliesNumbers {
  linkedApplyNumbers: string[];
}

export const AppliesNumbers = ({ linkedApplyNumbers }: IAppliesNumbers) => {
  const dictionary = useDictionary(Dictionary, DICTIONARY.MedicalReferrals)
    .referral.inquiries;
  const isDesktop = useIsDesktop();

  return (
    <>
      {linkedApplyNumbers.length === 0 ? null : (
        <Stack
          direction='row'
          alignItems='center'
          gap='6px'
          sx={{
            width: isDesktop
              ? linkedApplyNumbers.length > 1
                ? '300px'
                : '275px'
              : '100%',
          }}
        >
          <Avatar
            alt=''
            src={PurpleOutlinedAlert}
            sx={
              isDesktop
                ? { width: '20px', height: '20px', m: '6px 0 auto 0' }
                : {
                    width: '16px',
                    height: '16px',
                    m: '0 0 auto 0',
                  }
            }
          />
          {linkedApplyNumbers.length === 1 ? (
            <Typography
              variant='body6'
              sx={{
                maxWidth: isDesktop ? undefined : '250px',
              }}
            >
              {dictionary.furtherInquiry}{' '}
              <Link
                href={`applies/${linkedApplyNumbers[0]}`}
                sx={{
                  color: 'primary.blue',
                  textDecoration: 'none',
                  ':hover': {
                    textDecoration: 'underline',
                  },
                }}
              >
                {replaceZerosWithHyphen(linkedApplyNumbers[0])}
              </Link>{' '}
              {dictionary.concentrationOfInquiries}
            </Typography>
          ) : (
            <Typography variant='body6'>
              {dictionary.furtherInquiries}{' '}
              {dictionary.concentrationOfInquiries}:
              <Box>
                {linkedApplyNumbers.map((number: string, index: number) => {
                  return (
                    <Fragment key={index}>
                      {index > 0 ? ' , ' : ''}
                      <Link
                        href={`applies/${number}`}
                        sx={{
                          color: 'primary.blue',
                          textDecoration: 'none',
                          ':hover': {
                            textDecoration: 'underline',
                          },
                        }}
                      >
                        {replaceZerosWithHyphen(number)}
                      </Link>
                    </Fragment>
                  );
                })}
              </Box>
            </Typography>
          )}
        </Stack>
      )}
    </>
  );
};
